module.exports = __webpack_public_path__ + "img/driver_icon@2x.f3a05b63.png";